import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCheck,FiLock}=FiIcons;

function PlannerSidebar({sections,step,setStep}) {
  return (
    <aside className="planner-sidebar">
      <div className="planner-sidebar-intro">
        <span className="eyebrow">Your checklist</span>
        <h2>Plan your celebration</h2>
        <p>Complete each section at your own pace. You can return to any step at any time.</p>
      </div>

      <nav className="planner-step-list" aria-label="Planner steps">
        {sections.map((section,index)=> (
          <button
            type="button"
            key={section.id}
            className={[
              step===index ? 'active' : '',
              index<step ? 'complete' : ''
            ].filter(Boolean).join(' ')}
            onClick={()=> setStep(index)}
          >
            <span className="planner-step-number">
              {index<step ? <SafeIcon icon={FiCheck} /> : index+1}
            </span>
            <span className="planner-step-copy">
              <strong>{section.title}</strong>
              <small>{index<step ? 'Completed' : index===step ? 'In progress' : 'Not started'}</small>
            </span>
          </button>
        ))}
      </nav>

      <div className="planner-security-note">
        <SafeIcon icon={FiLock} />
        <span>
          <strong>Private and secure</strong>
          Your link is unique to this event.
        </span>
      </div>
    </aside>
  );
}

export default PlannerSidebar;